import { useParams } from 'react-router';
import { OrdersTable } from '../Orders/components/orders-table';
import { useOrdersById } from '../Orders/hooks/use-orders-byId';
import SideNav from 'Layout/SideNav';
import { Layout } from 'antd';
import HeaderBar from 'Layout/HeaderBar';
import FooterBar from 'Layout/FooterBar';
import BlurOverlayContainer from 'components/Overlay/BlurOverlayContainer';
import { FeatureIds } from '../../modules/featureControl/featuresConfig';
import Loader from 'components/Loader';
import { useState } from 'react';
import { type Order } from '../Orders/lib/types';
import { OrderDialog } from '../Orders/components/order-dialog';
import { CreateOrderDialog } from '../Orders/components/create-order-dialog';

function OrderListContainer() {
  const { orgId } = useParams<{ orgId: string }>();
  const { orders, loading } = useOrdersById(orgId);

  // Dialog state management (same as in Orders/OrderListContainer)
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [isViewEditDialogOpen, setIsViewEditDialogOpen] = useState(false);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [mode, setMode] = useState<'view' | 'edit'>('view');

  // Shared handlers for dialogs
  const handleCreateOrder = () => {
    setIsCreateDialogOpen(true);
  };

  const handleViewOrder = (order: Order) => {
    setSelectedOrder(order);
    setMode('view');
    setIsViewEditDialogOpen(true);
  };

  const handleEditOrder = (order: Order) => {
    setSelectedOrder(order);
    setMode('edit');
    setIsViewEditDialogOpen(true);
  };

  return (
    <>
      <SideNav />
      <Layout>
        <HeaderBar />
        <BlurOverlayContainer featureKey={FeatureIds.ORDERS}>
          <Layout.Content style={{ margin: '50px 24px 0' }}>
            {loading ? (
              <Loader />
            ) : (
              <>
                <OrdersTable
                  orders={orders}
                  orgId={orgId}
                  onViewOrder={handleViewOrder}
                  onEditOrder={handleEditOrder}
                  onCreateOrder={handleCreateOrder}
                />

                {/* Shared dialogs */}
                <CreateOrderDialog
                  open={isCreateDialogOpen}
                  onOpenChange={setIsCreateDialogOpen}
                  orgId={orgId}
                />

                <OrderDialog
                  open={isViewEditDialogOpen}
                  onOpenChange={setIsViewEditDialogOpen}
                  order={selectedOrder}
                  mode={mode}
                />
              </>
            )}
          </Layout.Content>
        </BlurOverlayContainer>
        <FooterBar />
      </Layout>
    </>
  );
}

export default OrderListContainer;
